import BasicProductInfoTab from './BasicProductInfoTab';

export default BasicProductInfoTab;
